import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { FORGE } from "@/constants/testIds";

export default function FinalPromptCard({ finalOutput, running }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (!finalOutput) return;
        try {
            await navigator.clipboard.writeText(finalOutput);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (e) {
            console.error(e);
        }
    };

    if (!finalOutput && !running) return null;

    return (
        <div
            data-testid={FORGE.finalPromptCard}
            className="rounded-lg border card-ambient overflow-hidden"
            style={{
                background:
                    "linear-gradient(135deg, rgba(197,160,89,0.06) 0%, rgba(255,255,255,1) 60%)",
                borderColor: "var(--profecia-gold-subtle)",
            }}
        >
            <div className="flex items-center justify-between px-6 py-4 border-b border-[color:var(--profecia-gold-subtle)]/60">
                <div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--profecia-gold)] font-mono">
                        Production-Ready Output
                    </div>
                    <h2 className="font-serif text-2xl text-[color:var(--text-main)] leading-none mt-1">
                        Final Higgsfield Prompt
                    </h2>
                </div>
                <button
                    type="button"
                    data-testid={FORGE.copyFinalButton}
                    onClick={handleCopy}
                    disabled={!finalOutput}
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[color:var(--profecia-gold)] text-white text-sm font-medium hover:bg-[color:var(--profecia-gold-hover)] disabled:opacity-40 disabled:cursor-not-allowed transition-colors duration-200"
                >
                    {copied ? (
                        <>
                            <Check size={14} strokeWidth={2.5} /> Copied
                        </>
                    ) : (
                        <>
                            <Copy size={14} strokeWidth={2} /> Copy Prompt
                        </>
                    )}
                </button>
            </div>
            <pre
                data-testid={FORGE.finalPromptText}
                className="font-mono text-[13px] leading-relaxed text-[color:var(--text-main)] whitespace-pre-wrap p-6 m-0 max-h-[500px] overflow-auto"
            >
                {finalOutput || (
                    <span className="text-[color:var(--text-muted)] italic font-sans">
                        Assembling final prompt…
                    </span>
                )}
            </pre>
        </div>
    );
}
